module.exports = __webpack_public_path__ + "img/spinner.2f27f045.gif";